/**
 * Authentication configuration
 *
 * This file is generated during project setup and determines whether
 * authentication features are enabled in the codebase.
 *
 * To enable/disable auth, re-run the setup script.
 */

export const AUTH_CONFIG = {
  /**
   * Whether Auth0 authentication is enabled.
   * This is set at setup time and compiled into the application.
   */
  enabled: true,
} as const;
